import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconArrowRightCircled = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1 1 5.925 1 12zm2 0a9 9 0 019-9 9 9 0 019 9 9 9 0 01-9 9 9 9 0 01-9-9zm8.939-4.475l-.622.562a.601.601 0 00-.041.85l.028.027L13.414 11H7.599a.599.599 0 00-.601.6v.8a.6.6 0 00.601.6h5.828l-2.101 2.027a.598.598 0 00-.016.848l.017.016.607.578a.597.597 0 00.829-.002l3.895-3.754a.978.978 0 000-1.415l-3.901-3.76a.599.599 0 00-.818-.013z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconArrowRightCircled.displayName = "IconArrowRightCircled";
